<app-header></app-header>
<p-toast
    position="top-right"
    [style]="{ top: '100px', right: '50px' }"
    [breakpoints]="{
        '575px': { width: '95vw', right: '0', left: '0', margin: 'auto' }
    }"
></p-toast>
<ngx-ui-loader
    [fgsColor]="demoService.config.bgsColor"
    [fgsPosition]="demoService.config.bgsPosition"
    [fgsSize]="demoService.config.fgsSize"
    [fgsType]="demoService.config.bgsType"
    [bgsColor]="demoService.config.bgsColor"
    [bgsOpacity]="demoService.config.bgsOpacity"
    [bgsPosition]="demoService.config.bgsPosition"
    [bgsSize]="demoService.config.bgsSize"
    [bgsType]="demoService.config.bgsType"
    [gap]="demoService.config.gap"
    [logoPosition]="demoService.config.logoPosition"
    [logoSize]="demoService.config.logoSize"
    [logoUrl]="demoService.config.logoUrl"
    [overlayColor]="demoService.config.overlayColor"
    [pbColor]="demoService.config.pbColor"
    [pbDirection]="demoService.config.pbDirection"
    [pbThickness]="demoService.config.pbThickness"
    [hasProgressBar]="demoService.config.hasProgressBar"
    [text]="demoService.config.text"
    [textColor]="demoService.config.textColor"
    [textPosition]="demoService.config.textPosition"
></ngx-ui-loader>
<div class="content-max">
    <router-outlet></router-outlet>
</div>
